<template>
  <div class="login-page">
    <Header />

    <FlashMessage ref="flashMessage" />

    <div class="login-image d-none d-lg-block">
      <img src="@/assets/img/default/login.png" alt="Login Image" />
    </div>

    <div class="login-form">
      <div class="form-container">
        <h2>Welcome Back!</h2>
        <p>Please login to your account</p>

        <LoadingIndicator v-if="loading" message="Loading..." />

        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <label for="email">Email</label>
            <input
              type="email"
              id="email"
              v-model="email"
              placeholder="Enter your email"
              required
            />
          </div>

          <div class="form-group">
            <label for="password">Password</label>
            <input
              type="password"
              id="password"
              v-model="password"
              placeholder="Enter your password"
              required
            />
          </div>

          <div class="form-options">
            <div class="form-check">
              <input type="checkbox" id="remember-me" v-model="rememberMe" />
              <label for="remember-me">Remember Me</label>
            </div>
            <!-- <a href="#" class="forgot-password">Forgot Password?</a> -->
            <RouterLink class="forgot-password" to="/reset-password" >Forgot Password?</RouterLink>
          </div>

          <button type="submit" class="login-button">Login</button>
        </form>

        <p class="signup-link">
          Don't have an account?
          <router-link to="/signup">Sign Up</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import Header from "@/components/Header.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import { Login } from "../../API-requests/Requests";
import { useAuthStore } from "@/Stores/authStore";
import { useRouter } from "vue-router";
import LoadingIndicator from "@/components/Loading_indicator.vue";

const router = useRouter();

const authStore = useAuthStore();
const email = ref("");
const password = ref("");
const token = ref("");
const refreshToken = ref("");
const rememberMe = ref(false);
const flashMessage = ref(null);
const loading = ref(false);
const error = ref(null);
const user = ref(null);

const handleLogin = async () => {
  try {
    loading.value = true;

    const resp = await Login(email.value, password.value);
    token.value = resp.access_token;
    user.value = resp.user;
    refreshToken.value = resp.access_token;

    authStore.StoreAuthData(token.value, user.value, refreshToken.value);
    flashMessage.value.showFlashMessage("success", "Succesfuly");
    if ([1, 2, 3].includes(user.value.position)) {
      router.push("/dashboard");
    } else {
      router.push("/product");
    }
  } catch (err) {
    console.error("Error authenticating user:", err);
    error.value = err.message || "Login failed";
    flashMessage.value.showFlashMessage("failure", error.value);
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.login-page {
  display: flex;
  min-height: 100vh;
}

.login-image {
  flex: 1;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-image img {
  max-width: 100%;
  height: 100vh;
  object-fit: cover;
}

.login-form {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #fff;
}

.form-container {
  max-width: 400px;
  width: 100%;
}

h2 {
  font-size: 2rem;
  margin-bottom: 10px;
  color: #333;
}

p {
  font-size: 1rem;
  color: #666;
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 0.9rem;
  color: #333;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  outline: none;
}

.form-group input:focus {
  border-color: #42b983;
  box-shadow: 0 0 5px rgba(66, 185, 131, 0.5);
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.form-check {
  display: flex;
  align-items: center;
}

.form-check input {
  margin-right: 10px;
}

.forgot-password {
  font-size: 0.9rem;
  color: #42b983;
  text-decoration: none;
}

.forgot-password:hover {
  text-decoration: underline;
}

.login-button {
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  color: #fff;
  background-color: #42b983;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.login-button:hover {
  background-color: #3aa876;
}

.signup-link {
  font-size: 0.9rem;
  color: #666;
  text-align: center;
  margin-top: 20px;
}

.signup-link a {
  color: #42b983;
  text-decoration: none;
}

.signup-link a:hover {
  text-decoration: underline;
}

@media (max-width: 992px) {
  .login-image {
    display: none;
  }

  .login-form {
    flex: 1;
    padding: 40px 20px;
  }
}
</style>
